import { HttpParams } from '@angular/common/http'
import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import {
    BaseComponent,
    FabDeliveryLookahead,
    FabDeliveryWeek,
    FabJob,
    FabPiece,
    FeatureType,
    ListItem,
    replaceListItemsIfChanged,
} from '../../shared'

@Component({
    selector: 'app-fab-deliveries',
    templateUrl: './fab-deliveries.component.html',
    styleUrls: ['./fab-deliveries.component.css'],
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class FabDeliveriesComponent extends BaseComponent {
    jobs: FabJob[] = []
    jobOptions: ListItem<string>[] = []
    selectedJobId = ''
    private appliedJobId = ''
    weeks: FabDeliveryWeek[] = []
    recentlyDelivered: FabPiece[] = []

    constructor() {
        super()
        this.refresh()
    }

    get canView() {
        return this.services.authentication.hasFeature([FeatureType.FabDeliveryLookaheadView])
    }

    onJobChanged() {
        if (this.selectedJobId === this.appliedJobId) return
        this.refresh(false)
    }

    refresh(showSpinner = true) {
        const requestedJobId = this.selectedJobId
        let params = new HttpParams().set('weeks', '3')
        if (requestedJobId) {
            params = params.set('fabJobId', requestedJobId)
        }

        this.cancelableRequest(
            '',
            showSpinner,
            this.services.data
                .load(showSpinner, showSpinner, this.services.data.get<FabDeliveryLookahead>('api/FabViews/DeliveryLookahead', params))
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        const view = result[0]
                        this.jobs = view.jobs || []
                        this.weeks = view.weeks || []
                        this.recentlyDelivered = view.recentlyDelivered || []
                        this.jobOptions = replaceListItemsIfChanged(this.jobOptions, [
                            new ListItem('', '(All jobs)'),
                            ...this.jobs.map(j => new ListItem(j.id, j.displayName || j.jobDescription || j.name || '')),
                        ])
                        this.appliedJobId = requestedJobId
                        if (this.selectedJobId !== requestedJobId) {
                            this.selectedJobId = requestedJobId
                        }
                    },
                }),
        )
    }

    riskClass(piece: FabPiece): string {
        if (piece.isOnHold || piece.riskLevel === 'Blocked') return 'border-secondary'
        if (piece.riskLevel === 'AtRisk') return 'border-danger'
        if (piece.riskLevel === 'DueSoon') return 'border-warning'
        return 'border-opacity-25'
    }

    formatDate(value: Date | string | null | undefined): string {
        if (!value) return '—'
        const d = new Date(value)
        if (isNaN(d.getTime())) return '—'
        return d.toISOString().slice(0, 10)
    }

    atRiskCount(week: FabDeliveryWeek): number {
        return (week.pieces || []).filter(p => p.riskLevel === 'AtRisk' || p.isOnHold).length
    }
}
